import Login from "./pages/ReportPages/ReportLogin";
import AppLogin from "./pages/ApplicationPages/ApplicationLogin";
import ApplicationPage from "./pages/ApplicationPages/ApplicationPage";
import "./App.css";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import ReportPage from "./pages/ReportPages/ReportPage";
import { Provider } from "react-redux";
import { persistor, store } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import AdminLogin from "./pages/AdminPages/AdminLogin";
import AdminIndex from "./pages/AdminPages/AdminIndex";
import DetailPage from "./pages/ReportPages/DetailPage";
import RankPage from "./pages/ReportPages/RankPage";
import NewbiePage from "./pages/ReportPages/NewbiePage";
import Home from "./pages/Home";
import PointPage from "./pages/PointPages/PointPage";
import PONO from "./pages/PointPages/PONO";
import { useEffect, useState, useCallback } from "react";
function App() {
  const [alertShown, setAlertShown] = useState(false);
  const [rotated, setRotated] = useState(false);

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const getLandscape = () => {
    if (window.screen.orientation?.type) {
      return window.screen.orientation.type.startsWith("landscape");
    }
    if (window.matchMedia) {
      return matchMedia("(orientation: landscape)").matches;
    }
    return window.innerWidth > window.innerHeight;
  };

  const needRotateBlock = useCallback(() => {
    const isLandscape = isMobile
      ? getLandscape()
      : window.innerWidth > window.innerHeight;

    const vv = window.visualViewport;
    const diff = vv ? window.innerHeight - vv.height : 0;
    const keyboardByVV = vv && diff > window.innerHeight * 0.05;

    const el = document.activeElement;
    const keyboardByFocus = el && /^(INPUT|TEXTAREA)$/i.test(el.tagName);

    return isLandscape && !(keyboardByVV || keyboardByFocus);
  }, [isMobile]);

  useEffect(() => {
    const handler = () => {
      const block = needRotateBlock();

      if (block && !alertShown) {
        alert(
          "PC에서는 화면 비율 및 가로 모드를 지원하지 않습니다.\n모바일 기기로 접속해 주시면 정상 이용이 가능합니다."
        );
        setAlertShown(true);
      }
      if (!block) setAlertShown(false);

      setRotated(block);
    };

    handler();
    window.addEventListener("resize", handler);
    window.addEventListener("orientationchange", handler);
    window.addEventListener("focusin", handler);
    window.addEventListener("focusout", handler);

    return () => {
      window.removeEventListener("resize", handler);
      window.removeEventListener("orientationchange", handler);
      window.removeEventListener("focusin", handler);
      window.removeEventListener("focusout", handler);
    };
  }, [alertShown, needRotateBlock]);

  if (rotated) {
    return (
      <div className="flex h-screen items-center justify-center text-center">
        모바일 기기로 접속해 주시면 정상 이용이 가능합니다.{" "}
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apply" element={<AppLogin />} />
            <Route path="/login" element={<Login />} />
            <Route path="/application" element={<ApplicationPage />} />
            <Route path="/daily" element={<ReportPage page="daily" />} />
            <Route path="/weekly" element={<ReportPage page="weekly" />} />
            <Route path="/monthly" element={<ReportPage page="monthly" />} />
            <Route path="/detail" element={<DetailPage page="daily" />} />
            <Route path="/rank" element={<RankPage page="daily" />} />
            <Route path="/newbie" element={<NewbiePage page="daily" />} />
            <Route path="/admin" element={<AdminLogin />}></Route>
            <Route path="/admin/main" element={<AdminIndex />}></Route>
            <Route
              path="/point/store_id/:store_id/phone_num/:phone_num"
              element={<PointPage />}
            />
            <Route path="/point/:store_id/:phone_num" element={<PointPage />} />

            <Route path="/point" element={<PONO />} />
          </Routes>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
